"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var axios_1 = require("axios");
var Alert_1 = require("./Alert");
var context_1 = require("./context");
function App(_a) {
    var className = _a.className;
    var _b = (0, context_1.useContext)(), eduzzId = _b.eduzzId, application = _b.application, action = _b.action, env = _b.env, returnTo = _b.returnTo, alertConfig = _b.alertConfig;
    var _c = React.useState(false), shouldShow = _c[0], setShouldShow = _c[1];
    var _d = React.useState(false), isIframeOpen = _d[0], setIsIframeOpen = _d[1];
    var iframeRef = React.useRef(null);
    var defaultOverflow = React.useRef('initial');
    React.useEffect(function () {
        function checkShouldShow() {
            return __awaiter(this, void 0, void 0, function () {
                var status_1, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, axios_1.default.get("".concat(env.API_URL, "/public/users/check-status/").concat(eduzzId))];
                        case 1:
                            status_1 = (_a.sent()).data;
                            setShouldShow(!(status_1 === null || status_1 === void 0 ? void 0 : status_1.isAuthorized));
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            console.error(err_1);
                            setShouldShow(false);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        checkShouldShow();
    }, [application, eduzzId, env]);
    React.useEffect(function () {
        if (action === 'newTab')
            return;
        window.addEventListener('message', function (e) {
            if (e.data === 'closeFIDCIframe') {
                setIsIframeOpen(false);
                document.body.style.overflow = defaultOverflow.current;
            }
        });
    }, [action]);
    if (!shouldShow)
        return null;
    if (!alertConfig.show)
        return null;
    function redirectToFIDC() {
        var currentPath = returnTo !== null && returnTo !== void 0 ? returnTo : window.location.href;
        var ref = window.open("".concat(env.FIDC_URL, "?returnTo=").concat(encodeURI(currentPath)), '_blank');
        (ref === null || ref === void 0 ? void 0 : ref.opener) === null;
    }
    function openIframe() {
        setIsIframeOpen(true);
        defaultOverflow.current = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Alert_1.default, { className: className, onClick: action === 'modal' ? openIframe : redirectToFIDC }), isIframeOpen && ((0, jsx_runtime_1.jsx)("iframe", { ref: iframeRef, src: env.FIDC_URL, style: {
                    position: 'fixed',
                    inset: 0,
                    border: 0,
                    margin: 0,
                    padding: 0,
                    overflow: 'hidden',
                    zIndex: 999999,
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#f9fafb'
                } }))] }));
}
exports.App = App;
